<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`"
  >
    <g fill="none" fill-rule="evenodd" :stroke="color" stroke-linejoin="round">
      <path stroke-linecap="round" d="M15 1l15 6.033L15 13 0 7.033 15 1z" />
      <path d="M25 9v9.104c-6.477 2.528-13.523 2.528-20 0V9" />
      <path stroke-linecap="round" d="M30 7v12M30 18l2 5h-4z" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "#fff"
    },
    width: {
      type: String,
      default: "33"
    },
    height: {
      type: String,
      default: "24"
    }
  }
};
</script>

<style lang="scss" scoped>
</style>